import { mergeAttributes, Node } from '@tiptap/core';
import {
  ReactNodeViewRenderer,
  NodeViewWrapper,
  NodeViewProps,
  NodeViewContent,
} from '@tiptap/react';
import { ConversationReplyBubble } from '@duke-hq/ui/components/Conversation/ConversationReplyBubble';

function ReplyComponentView(_props: NodeViewProps): React.ReactElement {
  return (
    <NodeViewWrapper>
      <ConversationReplyBubble>
        <NodeViewContent />
      </ConversationReplyBubble>
    </NodeViewWrapper>
  );
}

export const ReplyComponent = Node.create({
  name: 'replyComponent',

  group: 'block',

  content: 'inline*',

  draggable: true,

  parseHTML() {
    return [
      {
        tag: 'reply-component',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ['reply-component', mergeAttributes(HTMLAttributes), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ReplyComponentView);
  },
});
